import EditView from './EditView.vue';
import ListView from './ListView.vue';
import ShowView from './ShowView.vue';

export default { EditView, ListView, ShowView };